import React from "react";
import { getVisibleSpotTabs } from "../../utils/spotDetailUtils";

function GlassMenuChevron() {
    return (
        <svg aria-hidden className="profile-glass-menu__chevron" width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M4.5 6.75L9 11.25L13.5 6.75" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    );
}

export default function SpotDetailTabs({
    variant = "page",
    activeTab,
    onTabChange,
    tabsMenuOpen,
    setTabsMenuOpen,
    includeNotesTab = false,
}) {
    const visibleTabs = getVisibleSpotTabs({ includeNotes: includeNotesTab });
    const activeTabLabel = visibleTabs.find((tab) => tab.id === activeTab)?.label || "Раздел";

    const handleTabClick = (tabId) => {
        onTabChange?.(tabId);
        setTabsMenuOpen?.(false);
    };

    if (variant === "popup") {
        return (
            <div className="entity-popup__tabs-row">
                <button
                    type="button"
                    className="entity-popup__tabs-toggle"
                    onClick={() => setTabsMenuOpen?.((prev) => !prev)}
                    aria-expanded={tabsMenuOpen}
                    aria-controls="entityPopupTabs"
                >
                    <span>{activeTabLabel}</span>
                    <span aria-hidden>{tabsMenuOpen ? "▴" : "▾"}</span>
                </button>
                <div id="entityPopupTabs" className={`tabs entity-popup__tabs${tabsMenuOpen ? " is-open" : ""}`}>
                    {visibleTabs.map((tab) => (
                        <button
                            key={tab.id}
                            type="button"
                            className={`tab ${activeTab === tab.id ? "is-active" : ""}`}
                            onClick={() => handleTabClick(tab.id)}
                        >
                            {tab.label}
                        </button>
                    ))}
                </div>
            </div>
        );
    }

    return (
        <>
            <nav
                className={`profile-glass-menu spot-page__glass-menu${tabsMenuOpen ? " is-open" : ""}`}
                aria-label="Разделы точки"
            >
                <button
                    type="button"
                    className="profile-glass-menu__summary"
                    onClick={() => setTabsMenuOpen?.((prev) => !prev)}
                    aria-expanded={tabsMenuOpen}
                >
                    <span>{activeTabLabel}</span>
                    <GlassMenuChevron />
                </button>
                <div className="profile-glass-menu__body">
                    {visibleTabs.map((tab) => (
                        <button
                            key={tab.id}
                            type="button"
                            className={`profile-glass-menu__link profile-glass-menu__button${activeTab === tab.id ? " is-active" : ""}`}
                            onClick={() => handleTabClick(tab.id)}
                        >
                            {tab.label}
                        </button>
                    ))}
                </div>
            </nav>
            <div className="spot-page__tabs spot-page__tabs--desktop" role="tablist" aria-label="Разделы точки">
                {visibleTabs.map((tab) => (
                    <button
                        key={tab.id}
                        type="button"
                        role="tab"
                        aria-selected={activeTab === tab.id}
                        className={`spot-page__tab${activeTab === tab.id ? " is-active" : ""}`}
                        onClick={() => handleTabClick(tab.id)}
                    >
                        {tab.label}
                    </button>
                ))}
            </div>
        </>
    );
}
